module.exports = __webpack_public_path__ + "static/img/kitchener3.86735e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/kitchener3.jpg
// module id = 101
// module chunks = 9